import React from "react";
import AuthZButton from "../AuthzButton";
import "./index.css";

function BottomPageConfirmation(
    {
        confirmationText,
        buttonText,
        isButtonDisabled,
        onClick,
        onClickCancel,
        cancelText = 'Cancel'
    }) {
    return (
        <div className="bottom-page-confirmation">
            <div className="bottom-page-confirmation-text">{confirmationText}</div>
            <div className="bottom-page-button-container">
                <AuthZButton
                    authZButtonType="secondary"
                    onClick={onClickCancel}
                >
                    {cancelText}
                </AuthZButton>
                <AuthZButton
                    buttonDisabled={isButtonDisabled}
                    authZButtonType="primary"
                    onClick={onClick}
                >
                    {buttonText}
                </AuthZButton>
            </div>
        </div>
    );
}

export default BottomPageConfirmation;
